import React from "react";

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col, Badge,
} from "reactstrap";

import {getStats} from "../../components/helpers/StatsHelpers";
import {
  RiArrowRightLine, RiBookFill,
  RiEditFill,
  RiFolderMusicLine,
  RiLineChartLine,
  RiQuestionLine
} from "react-icons/ri";
import {SeoHelper} from "../../components/helpers/SeoHelper";

class AboutUs extends React.Component {
  state = {
    songBookCount: null
  };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  render() {
    return (
      <>
        <SeoHelper
            uri="/about-us"
            title="About The Worship Bible | Scripture-Based Worship Planning"
            description="Learn how The Worship Bible helps churches create meaningful, scripture-rooted worship services through curated song-flows."
        />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>about the worship bible</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="8">
                      <Card className="shadow border-0">
                        <CardBody className="py-2">
                          {/*<div className="icon icon-shape icon-shape-primary rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-check-bold" />*/}
                          {/*</div>*/}
                          {/*<div dangerouslySetInnerHTML={this.privacyPolicy} />*/}
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pt-3 pb-3">
                                About The Worship Bible
                              </h2>
                            </Col>
                          </Row>
                          <p className="MsoNormal">
                            At The Worship Bible, our mission is simple: to help worship leaders plan worship that is
                            faithful to Scripture, shaped with intention, and grounded in prayer.
                          </p>
                          <p className="MsoNormal">
                            Worship is more than selecting songs — it is shaping a whole Act of Worship that brings
                            Scripture, proclamation, prayer, and praise together with purpose. The Worship Bible exists
                            to support that calling.
                          </p>
                          <p className="MsoNormal">
                            Born from a deep love for Scripture and song, The Worship Bible helps you create
                            personalised song-flows from a rich and carefully curated library of Christian worship
                            music. You can begin with a Bible passage, a theme, a lectionary reading, or a hand-picked
                            selection of songs — and shape them into a coherent flow that serves the wider movement of
                            worship, from gathering to sending.
                          </p>
                          <p className="MsoNormal">
                            Our tools are designed to be simple, flexible, and purposeful. Rearrange songs easily, save
                            unlimited song-flows, and share them with your ministry team, church leaders, or fellow
                            musicians — without unnecessary complexity or technical barriers.
                          </p>
                          <p className="MsoNormal">
                            The Worship Bible is more than a piece of software. It is a resource created by worshippers,
                            for worshippers. We are committed to serving the Church by providing a platform that is
                            reliable, secure, and continually refined through prayerful listening and real-world
                            feedback.
                          </p>
                          <p className="MsoNormal">
                            We also believe trust is built through transparency. That’s why we are open about how we
                            handle security and personal data, using sensible safeguards appropriate for churches and
                            volunteers.
                          </p>

                          <p className="MsoNormal">
                            You can read more about our approach on our{" "}
                            <a href="/security">Security &amp; Data Protection</a> page.
                          </p>
                          <p className="MsoNormal">
                            If you have a question, a suggestion, or a song idea, we would love to hear from you.
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="shadow-sm border-0 bg-secondary">
                        <CardBody className="py-3">
                          <h2
                              className="text-primary text-uppercase mb-4"
                              style={{fontSize: "1rem" }}
                          >
                            Why churches trust us
                          </h2>

                          <div className="d-flex align-items-start mb-3">
                            <RiBookFill className="text-primary mr-2 mt-1" />
                            <p className="MsoNormal mb-0">
                              Built by active worship leaders who understand the realities of church life.
                            </p>
                          </div>

                          <div className="d-flex align-items-start mb-3">
                            <RiEditFill className="text-primary mr-2 mt-1" />
                            <p className="MsoNormal mb-0">
                              Designed with Scripture at the centre of every song-flow.
                            </p>
                          </div>

                          <div className="d-flex align-items-start mb-3">
                            <RiLineChartLine className="text-primary mr-2 mt-1" />
                            <p className="MsoNormal mb-0">
                              Clear, transparent pricing with no hidden costs.
                            </p>
                          </div>

                          <div className="d-flex align-items-start mb-3">
                            <RiFolderMusicLine className="text-primary mr-2 mt-1" />
                            <p className="MsoNormal mb-0">
                              Secure sign-in and responsible data handling.
                            </p>
                          </div>

                          <div className="d-flex align-items-start mb-3">
                            <RiArrowRightLine className="text-primary mr-2 mt-1" />
                            <p className="MsoNormal mb-0">
                              Suitable for churches of all sizes — from individuals to teams.
                            </p>
                          </div>

                          <div className="d-flex align-items-start">
                            <RiQuestionLine className="text-primary mr-2 mt-1" />
                            <p className="MsoNormal mb-0">
                              Continually shaped by real church feedback and lived experience.
                            </p>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col lg="8">
                      <Card className="shadow border-0 mt-3">
                        <CardBody className="py-2">
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pt-3 pb-3">
                                Who we are
                              </h2>
                            </Col>
                          </Row>
                          <p className="MsoNormal">
                            Matt and Mark are members of Market Rasen New Life Church in Lincolnshire. Matt shared his vision for The Worship Bible with Mark, and from that moment the vision began to take shape as a practical resource for the wider Church.
                          </p>
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pt-3 pb-3">
                                Matt
                              </h2>
                            </Col>
                          </Row>
                          <p className="MsoNormal">
                            Matt is a worship leader with over 30 years of experience and the heart behind The Worship Bible.
                            Bible.
                          </p>
                          <p className="MsoNormal">
                            “This site began as a spark from God — His idea, His inspiration. I’ve simply had the privilege of shaping it into something practical, prayerful, and (I hope) profoundly helpful. My desire is to help worship leaders find songs that align with Scripture and draw people closer to God.”
                          </p>
                          <p className="MsoNormal">
                            “Sing to the Lord a new song; sing to the Lord, all the earth… declare his glory among the
                            nations, his marvellous deeds among all peoples.”
                            — Psalm 96:1,3
                          </p>
                          <p className="MsoNormal">
                            Whether planning a Sunday service, leading a small group, or building worship around sermon themes or Scripture readings, The Worship Bible is designed to save time and reduce pressure. Every song and book pairing has been carefully curated with the aim of supporting worship that is thoughtful, faithful, and pastorally sensitive.
                          </p>
                          <p className="MsoNormal">
                            “Whatever you do, whether in word or deed, do it all in the name of the Lord Jesus…”
                            — Colossians 3:17
                          </p>
                          <p className="MsoNormal">
                            The Worship Bible exists to serve worship leaders — to equip, encourage, and give back time and energy for what matters most.
                          </p>
                          <Row>
                            <Col>
                              <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pt-3 pb-3">
                                Mark
                              </h2>
                            </Col>
                          </Row>
                          <p className="MsoNormal">
                            Mark is an IT contractor with over 30 years of commercial experience as a developer and technical architect.
                          </p>
                          <p className="MsoNormal">
                            After being accepted into Irish Baptist College in 1989, Mark was asked to defer for a year due to his age. During that time, he sensed God calling him not away from technology, but deeper into it as a means of service.
                          </p>
                          <p className="MsoNormal">
                            Mark went on to study Information Technology and Religious Studies at Canterbury Christ Church College (now Canterbury Christ Church University), and has since worked across multiple countries, industries, and government departments.
                          </p>
                          <p className="MsoNormal">
                            He brings a strong focus on security, reliability, and sustainability — ensuring that The Worship Bible is technically robust, safe to use, and built for long-term service to the Church.
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}

      </>
    );
  }
}

export default AboutUs;
